<template>
  <b-modal
    v-if="typeform"
    v-model="show"
    size="lg"
    ok-title="Kaydet"
    cancel-title="Vazgeç"
    :ok-disabled="isLoading"

    :title="typeform.name"
    @ok="type === 'create' ? createTypeform($event) : updateTypeform($event)"
  >
    <Loader
      v-if="isLoading"
      style="opacity: 0.5"
    />
    <b-form-group>
      <label>name</label>
      <input
        v-model="typeform.name"
        type="text"
        class="form-control"
        placeholder="name"
      >
    </b-form-group>
    <b-form-group>
      <label>id</label>
      <input
        v-model="typeform.id"
        type="text"
        class="form-control"
        placeholder="id"
      >
    </b-form-group>
  </b-modal>
</template>
<script>
import Loader from '@/components/Loader';

import { API } from '@/services/';
import {
  API_CREATE_NEW_TYPEFORM, API_UPDATE_TYPEFORM_BY_ID,
} from '@/helpers/config';

export default {
  components: {
    Loader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'create',
      validator: value => ['create', 'update'].indexOf(value) !== -1
      ,
    },
    data: {
      type: Object,
      default: () => {},
      required: value => value === 'update',
    },
  },
  data: () => ({
    // it is used for avoiding direct prop mutation
    show: false,
    typeform: null,
    isLoading: false,
  }),
  watch: {
    // when v-model is changed in parent, update show value
    value(val) {
      this.show = val;
    },
    // when show value is updated, emit new value to parent (v-model)
    show(val) {
      this.$emit('input', val);

      // if modal will be visible
      if (val) this.resetModalData();
    },
  },
  created() {
    this.show = this.value;
  },
  methods: {
    resetModalData() {
      if (this.type === 'create') {
        this.typeform = {
          id: null,
          name: null,
        };
      } else if (this.type === 'update') {
        this.typeform = JSON.parse(JSON.stringify(this.data));
        delete this.typeform._id;
        delete this.typeform.created;
        delete this.typeform.__v;
      }
    },
    createTypeform(e) {
      e.preventDefault();
      this.isLoading = true;

      API
        .post(API_CREATE_NEW_TYPEFORM, this.typeform)
        .then((response) => {
          this.$snotify.success(response.data.message);
          this.isLoading = false;
          this.show = false;
        })
        .catch((error) => {
          this.$snotify.error(error.response.data.message);
          this.isLoading = false;
        });
    },
    updateTypeform(e) {
      e.preventDefault();
      this.isLoading = true;

      API
        .put(API_UPDATE_TYPEFORM_BY_ID + this.data.id, this.typeform)
        .then((response) => {
          this.$snotify.success(response.data.message);
          this.isLoading = false;
          this.show = false;
        })
        .catch((error) => {
          this.$snotify.error(error.response.data.message);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped>

</style>
